import _extends from "@babel/runtime/helpers/extends";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _createClass from "@babel/runtime/helpers/createClass";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import Option from './Option';
import './OptionTabs.less';

var OptionTabs = /*#__PURE__*/function (_Component) {
  _inheritsLoose(OptionTabs, _Component);

  _createClass(OptionTabs, null, [{
    key: "propTypes",
    get: function get() {
      return {
        onChange: PropTypes.func,
        selectedOption: PropTypes.string,
        options: PropTypes.arrayOf(PropTypes.shape({
          id: PropTypes.string,
          panelId: PropTypes.string,
          icon: PropTypes.node,
          iconSelected: PropTypes.node,
          label: PropTypes.string,
          enabled: PropTypes.bool,
          optionDescription: PropTypes.string
        })),
        selectedOptionIcons: PropTypes.arrayOf(PropTypes.node),
        displayRadioButtons: PropTypes.bool,
        displayDivider: PropTypes.bool
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        optionIcons: [],
        selectedOptionIcons: [],
        displayRadioButtons: true,
        displayDivider: true
      };
    }
  }]);

  function OptionTabs(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.handleSelectionClick = _this.handleSelectionClick.bind(_assertThisInitialized(_this));
    _this.state = {
      selectedOption: props.selectedOption
    };
    return _this;
  }

  var _proto = OptionTabs.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
    var selectedOption = _ref.selectedOption;

    if (typeof selectedOption !== 'undefined') {
      this.setState({
        selectedOption: selectedOption
      });
    }
  };

  _proto.handleSelectionClick = function handleSelectionClick(id) {
    this.selectedOption = id;
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "options-tab-container",
      role: "tablist"
    }, this.options);
  };

  _createClass(OptionTabs, [{
    key: "selectedOption",
    set: function set(option) {
      this.props.onChange(option);
      this.setState({
        selectedOption: option
      });
    }
  }, {
    key: "options",
    get: function get() {
      var _this2 = this;

      return _.map(this.props.options, function (option) {
        return /*#__PURE__*/React.createElement(Option, _extends({
          className: "options-tab-icon",
          key: option.id
        }, option, {
          onClick: _this2.handleSelectionClick,
          selected: _this2.state.selectedOption === option.id,
          displayRadioButtons: _this2.props.displayRadioButtons,
          displayDivider: _this2.props.displayDivider
        }));
      });
    }
  }]);

  return OptionTabs;
}(Component);

export { OptionTabs as default };